module.exports = __webpack_public_path__ + "static/media/mdo.44076b78.svg";